<template>
  
  <div id="download-wrap">
    <div class="download-head">
      <h2>DOWNLOAD IT!</h2>
      <p :style="{opacity: isHome ? 0 : 1}">{{currentTab}} wallpapers</p>
      <div class="back-btn" :style="{opacity: isHome ? 0 : 1, visibility: isHome ? 'hidden' : 'visible'}"
        @click="backHome"
      >
        <img src="../assets/download-back.svg" />
        <p >Back to all</p>
      </div>
    </div>
    <div class="download-home">
      <div class="download-tab first-tab selected">
        <div class="choose-col">
          <div class="choose-btn" @click="choose('mobile')">
            <img class="choose-img" src="../assets/icona-mobile.png" />
            <p>Phone wallpapers</p>
          </div>
        </div>
        <div class="choose-col" @click="choose('desktop')">
          <div class="choose-btn">
            <img class="choose-img" src="../assets/icona-desktop.png" />
            <p>Desktop wallpapers</p>
          </div>
        </div>
        <div class="choose-col" @click="choose('badges')">
          <div class="choose-btn">
            <img class="choose-img" src="../assets/icona-badges.png" />
            <p>Badges</p>
          </div>
        </div>
      </div>
      <div class="download-tab mobile-tab">
        <div class="list--tab list--mobile">
          <div class="list--row" v-for="(row, index) in arrayMobile" :key="index">
            <img class="preview" :src="row.assetPreview" />
            <p>{{row.nameDownload}}</p>
            <a @click.prevent="downloadItem(row)">
              <img src="../assets/icon-download.svg" />
            </a>
          </div>
        </div>
      </div>
      <div class="download-tab desktop-tab">
        <div class="list--tab list--desktop">
          <div class="list--row" v-for="(row, index) in arrayDesktop" :key="index">
            <img class="preview" :src="row.assetPreview" />
            <p>{{row.nameDownload}}</p>
            <a @click.prevent="downloadItem(row)">
              <img src="../assets/icon-download.svg" />
            </a>
          </div>
        </div>
      </div>
      <div class="download-tab badges-tab">
        <div class="list--tab list--desktop">
          <div class="list--row" v-for="(row, index) in arrayBadges" :key="index">
            <img class="preview" :src="row.assetPreview" />
            <p>{{row.nameDownload}}</p>
            <a @click.prevent="downloadItem(row)">
              <img src="../assets/icon-download.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {gsap, TimelineMax, Power2} from 'gsap'
import Axios from 'axios'

export default {
  name: 'Download',
  data(){
    return{
      choosenTab: '',
      isHome: true,
      currentTab: '',
      arrayMobile: [
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-sformato-vegetale.png'),
          nameDownload: 'Vegatable pie wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-merluzzo.png'),
          nameDownload: 'Cod wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-tortelli-alle-erbette.png'),
          nameDownload: 'Herbs wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-mela.png'),
          nameDownload: 'Apple wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-anans.png'),
          nameDownload: 'Pinapple wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-pasta-e-broccoli.png'),
          nameDownload: 'Pasta wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/mobile-wallpaper/wallpaper-pera.png'),
          nameDownload: 'Pear wallpaper',
          linkDownload: ''
        }
      ],
      arrayDesktop: [
        {
          assetPreview: require('../assets/desktop-wallpaper/wallpaper-chat-with-the-planet.png'),
          nameDownload: 'Chat with the planet wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/desktop-wallpaper/wallpaper-feed-a-sustainable-future.png'),
          nameDownload: 'Feed a sustainable & healthy future wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/desktop-wallpaper/wallpaper-do-your-part-eat-smart.png'),
          nameDownload: 'Do your part, eat smart wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/desktop-wallpaper/wallpaper-balance-your-meal.png'),
          nameDownload: 'Better meals, better planet wallpaper',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/desktop-wallpaper/wallpaper-limit-co2-in-the-menu.png'),
          nameDownload: 'Eat healthy and limit CO2 in the menu wallpaper',
          linkDownload: ''
        }
        
      ],
      arrayBadges: [
        {
          assetPreview: require('../assets/badges/badge-chat-with-the-planet.png'),
          nameDownload: 'Chat with the planet badge',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/badges/badge-feed-a-sustainable-future.png'),
          nameDownload: 'Feed a sustainable & healthy future badge',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/badges/badge-do-your-part-eat-smart.png'),
          nameDownload: 'Do your part, eat smart badge',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/badges/badge-balance.png'),
          nameDownload: 'Better meals, better planet badge',
          linkDownload: ''
        },
        {
          assetPreview: require('../assets/badges/badge-limit-co2-in-the-menu.png'),
          nameDownload: 'Eat healthy and limit CO2 in the menu badge',
          linkDownload: ''
        },
      ]
    }
    
  },
  methods: {
    choose(type){
      let getTab = document.querySelector(`.${type}-tab`);
      let fistStep = document.querySelector('.first-tab');
      
      this.isHome = false;
      this.currentTab = type.charAt(0).toUpperCase() + type.slice(1);

      gsap.to(fistStep, {autoAlpha: 0, duration: .5, onComplete: () => {
        fistStep.classList.remove('selected')

        getTab.style.display = 'block';
        gsap.to(getTab, {autoAlpha: 1,duration: .5,  onComplete: () => {
          getTab.classList.add('selected')
        }})
      }})

    },
    backHome(){
      let selectedTab = document.querySelector(`.download-tab.selected`);
      let fistStep = document.querySelector('.first-tab');
      
      this.isHome = true;
      

      gsap.to(selectedTab, {autoAlpha: 0, duration: .5, onComplete: () => {
        selectedTab.classList.remove('selected')
        gsap.to(fistStep, {autoAlpha: 1,duration: .5,  onComplete: () => {
          fistStep.classList.add('selected')
          selectedTab.style.display = 'none';
          this.currentTab = '';
        }})
      }})
    },
    downloadItem ({ assetPreview, nameDownload }) {
      Axios.get(assetPreview, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/png' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = nameDownload
          link.click()
          URL.revokeObjectURL(link.href)
      }).catch(console.error)
    }
  },
  mounted(){
    // gsap.to('#download-wrap', {duration: .75, left: 0, ease: Power2.easeInOut})
    this.$store.dispatch('setMenuCtaVisibility',true);
  }
}
</script>

<style lang="scss">
  #download-wrap{
    position: absolute;
    height: 100vh;
    width: 100%;
    background-image: url('../assets/bg-download.png');
    background-size: cover;
    background-position: 50%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .download-head{
      flex: 1 0 160px;
      h2{
        color: #fff;
        margin: 0 auto;
        text-align: center;
        font-size: 48px;
        line-height: 80px;
        padding-top: 48px;
        font-weight: 800;
      }
      p{
        font-size: 18px;
        line-height: 24px;
        margin: 0 auto;
        color: #fff;
        transition: opacity .5s ease-out;
        text-align: center;
      }
      @media screen and(max-width: 767px){
        flex: 1 0 80px;
        h2{
          font-size: 24px;
          line-height: 40px;
        }
      }
    }
    
    .back-btn{
      position: absolute;
      height: 80px;
      cursor: pointer;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      left: 50px;
      top: 50px;
      visibility: hidden;
      opacity: 0;
      transition: opacity .5s ease-out;
      img{
        margin-right: 20px;
      }
      @media screen and(max-width: 767px){
        left: 20px;
        top: 30px;
        p{
          display: none;
        }
      }
    }
    .download-home{
      position: relative;
      flex: 1 0 calc(100% - 160px);
      width: 100%;
      overflow: hidden;
      overflow-y: scroll;
      @media screen and(max-width: 767px){
        flex: 1 0 calc(100% - 80px);
      }
      .download-tab{
        position: absolute;
        margin: 0 auto;
        max-width: 1280px;
        left: 30px;
        right: 30px;
        overflow: hidden;
        width: calc( 100% - 60px);
        padding: 0 30px;
        top: 0;
        align-items: center;
        justify-content: center;
        visibility: hidden;
        opacity: 0;
        display: none;
        left: 50%;
        transform: translateX(-50%);
        @media screen and(max-width: 767px){
          flex-direction: column;
          width: 100%;
          min-height: 100%;
          left: 0;
          right: 0;
          padding: 0;
          .choose-col{
            max-height: 33%;
            .choose-btn{
              height: 100%;
            }
            .choose-img {
              height: 100px;
              width: auto;
              
            }
          }
        }
        &.selected{
          position: relative;
          visibility: visible;
          left: 0%;
          transform: translateX(0%);
          opacity: 1;
        }
        &.first-tab{
          display: flex;
        }
        .choose-col{
          flex: 1 1 33%;
          max-width: 33%;
          text-align: center;
          color: #fff;
          img{
            display: block;
            width: 90%;
            margin: 0 auto;
          }
          p{
            margin: 0 auto;
            text-align: center;
          }
          .choose-btn{
            cursor: pointer;
          }
          @media screen and(max-width: 767px){
            flex: 1 1 33%;
            max-width: 100%;
          }
        }
        .list--tab{
          position: relative;
          width: 100%;
          margin: 0 auto;
          padding: 50px 0;
        }
        .list--row{
          position: relative;
          width: 60%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 auto 60px;
          .preview{
            flex: 1 1 33%;
            max-width: 33%;
          }
          p{
            flex: 1 1 33%;
            text-align: left;
            text-align: left;
            color: #fff;
            padding-left: 40px;
          }
          a{
            display: flex;
            justify-content: flex-end;
            flex: 1 1 50px;
            cursor: pointer;
            max-width: 50px;
            img{
              width: 50px;
            }
          }

          @media screen and(max-width: 767px){
            flex-direction: column;
            p{
              padding: 50px 0 20px;
              text-align: center;
            }
            .preview{
              max-width: 100%;
            }
          }
        }
        &.mobile-tab{
          .list--tab{
            display: flex;
            flex-wrap: wrap;
            .list--row{
              // flex: 1 1 50%;
              // max-width: 50%;
            }
          }
        }
      }
    }
  }
</style>